import {AuditGroup} from "@/pages/pagespeed/report/body/AuditGroup.tsx";
import {Filmstrip} from "@/pages/pagespeed/report/body/Filmstrip.tsx";
import {getOpportunities} from "@/pages/pagespeed/report/body/legacyHelpers.tsx";
import {PagespeedLHR} from "@/pages/pagespeed/types.ts";

interface SummaryTabProps {
  lhr: PagespeedLHR;
}
export const SummaryTab = ({lhr}: SummaryTabProps) => {
  const opportunities = getOpportunities(lhr) || [];
  return (
    <>
      <Filmstrip audits={lhr.audits} />
      {opportunities.length > 0 && <AuditGroup title="Top Issues" audits={opportunities} />}
    </>
  );
};
